export const getCsrfToken = () => {
  const metaCsrf = document.querySelector("meta[name='csrf-token']");
  return metaCsrf ? metaCsrf.getAttribute('content') : 'testenv';
}
